import { render } from "./paymentMethodSelection.vue?vue&type=template&id=4cfda16a&scoped=true&ts=true"
import script from "./paymentMethodSelection.vue?vue&type=script&lang=ts"
export * from "./paymentMethodSelection.vue?vue&type=script&lang=ts"

import "./paymentMethodSelection.vue?vue&type=style&index=0&id=4cfda16a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfda16a"]])

export default __exports__